export default __webpack_public_path__ + "static/media/00.294f92ca.jpg";